import React from 'react'
import '../../font/iconfont'
import './index.less'

export default (props) => {
  return (<svg
    style={props.style}
    className={`whiteboard-item-icon ${props.className}`}
    aria-hidden="true"
  >
    <use xlinkHref={`#whiteboard-${props.type}`} />
  </svg>)
}


// WEBPACK FOOTER //
// ./src/components/Icon/index.js